<template> 
   <div class="containerNcm">
  <div class="painel2">
        <img src="/arqlef/arqlef2.svg" alt="" />
        </div>
 
     <p style="color: #000;font-size:25px;font-weight:700;margin: 65px 50px 25px 50px;">Importar notas do computador -  {{$store.state.tipoNota}}</p>  
      <div style="width: 100%;max-width: 900px; margin: 0 auto;">  
          <label for="assetsFieldHandle" style="display: flex; align-items: center; justify-content: center; background: #009188; cursor: pointer; width: 100%; height: 40px; border-radius: 2px; margin: 60px 0px 25px;"><p style="font-size: 14px; margin: 0px; color: rgb(255, 255, 255);font-weight:600;"><i class=" fas fa-file-upload" style="margin: 0px 20px; font-size: 18px;color: #fff;"></i> Clique aqui para adicionar arquivos</p></label>
       <input type="file" multiple name="fields[assetsFieldHandle][]" id="assetsFieldHandle" style="display: none;"       
      class="w-px h-px opacity-0 overflow-hidden absolute" @change="onChange" ref="file" accept=".zip,.xml" />
       <div class="flex w-full h-screen items-center justify-center text-center">
        <div class="p-12 bg-gray-100 border border-gray-300" @dragover="dragover" @dragleave="dragleave" @drop="drop" style="    flex-direction: column;display: flex;border-radius: 8px;align-items:center;justify-content: center;">
            <label for="assetsFieldHandle" class="block cursor-pointer" style=" width: 100%;height: 100%;">
                <div style="color: #7e7e7e;cursor: pointer;font-size: 14px;font-weight: 400;width: 100%;display: flex;height: 100%;align-items: center; justify-content: center;" >
                    <span style="padding: 44px;" v-show="spiner && exibir">Se preferir, arraste aqui os seus arquivos .ZIP e .XML </span>    <span style="padding: 44px;"  v-show="!spiner"><b-spinner label="Spinning"></b-spinner></span>            
                </div>
            </label>
            <ul class="mt-4" v-if="filelist.length" v-cloak v-show="spiner">
            <li class="text-sm p-1" v-for="file in filelist" :key="file">
                {{file.name }}<button class="ml-2" type="button" @click="remove(filelist.indexOf(file))" title="Remove file">remove</button>
            </li>
            </ul>
        </div>
        </div>
        </div><br>
        <p v-show="log.length != 0" style="margin-bottom:0px;font-weight: bold;">Arquivos Enviados: <span style="color:green;">{{log.filter(e=>e.cod == 2).length}}</span></p>
        <p v-show="log.length != 0" style="margin-bottom:0px;font-weight: bold;">Arquivos Inválidos: <span style="color:red;">{{log.filter(e=>e.cod == 1).length}}</span></p>
        
        <p :style="{'font-weight':'bold','color': txtRetorno== 'Arquivos enviados com sucesso' ? 'green': 'red','margin-bottom': '0',}" >{{txtRetorno}}</p>       
   
        <div style="display: flex; align-items: center; justify-content: center;;margin-top: 15px;">
            <button class="continue-button" @click="$router.push({'name':'notas'})" style="margin-right:10px;">Voltar</button>
            <button class="continue-button" @click="finalizar" style="margin-left:10px;">Finalizar importação</button>
        </div>    
</div>
     
</template>
    
<script>
import config  from '../services/config'
export default {
    data(){
        return{
            filelist:[],
            spiner:true,
            exibir:true,
            txtRetorno:'',
            log:[]
        }
    },
    methods:{  
       async finalizar(){      
           console.log( this.filelist)
           this.log = []
           this.spiner = false
           this.txtRetorno = ''
           
            if(this.$store.state.tipoNota == 'NFe'){
                let x = 0;
                this.filelist.forEach(e=>{
                    let pattern = /xml/i;
                    let result = e.name.match(pattern);
                    if(result != null){
                        x++
                    }
                })
                if(x >=15){
                    this.txtRetorno = 'Limite de 15 xmls. Faço um zip para pode enviar todos de uma vez.'
                }else{
                    for(let e of this.filelist){
                        let formXml = new FormData()  
                        formXml.append("file",e)     
                        let result = await config.uploadNfe(this.$store.state.idEmpresa,formXml)
                        if(result.status>=300){
                            this.log.push({"arquivo":e.name,"motivo":"Arquivo Invalido","cod":1})
                        }else{
                            this.log.push({"arquivo":e.name,"motivo":"Arquivo enviado com sucesso","cod":2})
                        }
                    }                  
                }
            }else if(this.$store.state.tipoNota == 'NFCe'){
                let formXml = new FormData()              
                let i = 0;
                this.filelist.forEach(e=>{
                    formXml.append(`file[${i}]`,e)
                    i++
                })         
                formXml.append("empresa",this.$store.state.idEmpresa)
                let result = await config.uploadNfce(formXml) 
                console.log(result.data.length)        
                if(result.status <=205){
                    if(result.data.length==0){
                        this.txtRetorno = 'Erro ao importar seus arquivos'
                    }else{
                        this.txtRetorno = 'Arquivos enviados com sucesso'
                    }                    
                } else{
                    this.txtRetorno = 'Erro ao importar seus arquivos'
                }
            }
            this.filelist = []
            this.spiner = true
            this.exibir = true
       },
    onChange() {
        this.exibir = false
      this.filelist = [...this.$refs.file.files];
    },
    remove(i) {
      this.filelist.splice(i, 1);
      if(this.filelist.length ==0){
          this.exibir = true
      }
    },
    dragover(event) {
      event.preventDefault();
      if (!event.currentTarget.classList.contains('bg-green-300')) {
        event.currentTarget.classList.remove('bg-gray-100');
        event.currentTarget.classList.add('bg-green-300');
      }
    },
    dragleave(event) { 
      event.currentTarget.classList.add('bg-gray-100');
      event.currentTarget.classList.remove('bg-green-300');
    },
    drop(event) {
      event.preventDefault();
      this.$refs.file.files = event.dataTransfer.files;
      this.onChange(); 
      event.currentTarget.classList.add('bg-gray-100');
      event.currentTarget.classList.remove('bg-green-300');
    }
  
    },
    mounted(){
        document.documentElement.scrollTop = 0;
    }
    

}
</script>

<style>
button:focus{
outline: none;
}
li.text-sm.p-1 {
    font-size: 13px;
}
label {
    color: #7e7e7e;
    cursor: pointer;
    font-size: 14px;
    font-weight: 400;
}
li{
    color: #3e3e3e;
}
li  button{
    color: #1696e7;
    outline: medium none;
    background: #fff;
    border: none;
}
.radio-component>input:active+label>.input-box, .radio-component>input:checked+label>.input-box, .radio-component>input:focus+label>.input-box {
    background: #009188!important;
    background-image: none!important;
    -webkit-box-shadow: none!important;
    box-shadow: none!important;
}
.large-bar-radio {
    margin: 0 0 0 20px;
}
.radio-component>input {
    opacity: 0;
    position: absolute;
}
.radio-component>input:checked+label>.input-box>.input-box-circle {
    opacity: 1;
    margin: 22%;
    width: 56%;
    height: 56%;
}
label{
    margin-bottom: 0px;
}
.radio-component>input+label>.input-box>.input-box-circle {
    display: block;
    margin: 50%;
    width: 0;
    height: 0%;
    background: #fff;
    border-radius: 50%;
    opacity: 0;
    transition: width .15s ease-in,height .15s ease-in,margin .15s ease-in;
}
.radio-component>input+label>.input-box {
    display: inline-block;
    border: 1px solid #000;
    border-radius: 50%;
    margin: 0;
    padding: 0;
    width: 1em;
    height: 1em;
    background: #fff;
    overflow: hidden;
    vertical-align: -5%;
    user-select: none;
}

.radio-component>input+label>.input-box {
    border-color: #009188!important;
    background: #fff!important;
}
.large-bar p{
font-size: 14px;
 margin: 0px 0px 0px 20px; 
 font-weight: 700; 
 color: rgb(56, 56, 56); 
 line-height: 15px;
}
.large-bar {    
    display: flex;
    align-items: center;  
    justify-content: flex-start;
    min-height: 70px!important;
    max-height: 300px!important;
    height: 100px!important;
    background: #eee;
    max-width: 600px;
    width: 100%;
    border-radius: 5px;   
    transition: all .2s;
    border-left: 10px solid #009188;
}
.continue-button {

    width: 160px;
    height: 40px;
    background: #009188;
    color: #fff;
    font-size: 15px;
    font-style: italic;
    border-radius: 5px;
    margin-bottom: 50px;
    border:none;
}
</style>